import { APP_STORE_URL, PLAY_STORE_URL } from "../print/lib/device";
import shops from "../data/shops.json";

/* Cities with at least one partner shop, in the order of the shop snapshot (scripts/fetch-shops.js). */
const CITY_NAMES = shops.cities.map((c) => c.name);

/** The cities as prose: "Solapur, Pune, Mumbai and Jalandhar" (pass "or" for the other conjunction). */
export function cityList(conjunction = "and") {
  if (CITY_NAMES.length < 2) return CITY_NAMES.join("");
  return `${CITY_NAMES.slice(0, -1).join(", ")} ${conjunction} ${CITY_NAMES[CITY_NAMES.length - 1]}`;
}

/* Site-wide facts used by titles, meta tags and structured data. Keep this the single source. */
export const SITE = {
  name: "PrintAnywhere",
  tagline: "We accept print from anywhere",
  url: "https://printanywhere.in",
  logo: "https://printanywhere.in/img/print_anywhere_logo2.png",
  ogImage: "https://printanywhere.in/img/og-cover-v2.png",
  description: `Upload a PDF or photo, pay online and collect your printout at a PrintAnywhere partner shop near you in ${cityList()}. No WhatsApp, no queue.`,
  email: "info@printanywhere.in",
  supportEmail: "support@printanywhere.in",
  phone: "+91 91680 81867",
  phoneE164: "+919168081867",
  legalName: "Solapurmall Information Technology Private Limited",
  brandShort: "SMIT",
  address: { street: "23/B, Rangraj Nagar, Behind Market Yard", city: "Solapur", region: "Maharashtra", postalCode: "413006", country: "IN" },
  playStore: PLAY_STORE_URL,
  appStore: APP_STORE_URL,
  sameAs: [PLAY_STORE_URL, APP_STORE_URL, "https://www.linkedin.com/in/vinaylomate/", "https://www.smittechnologies.com/"],
  cities: CITY_NAMES,
};

export function absoluteUrl(path = "/") {
  if (/^https?:\/\//.test(path)) return path;
  const clean = path.split("#")[0].split("?")[0];
  return `${SITE.url}${clean === "/" ? "/" : clean.replace(/\/+$/, "")}`;
}
